import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import { useTranslation } from "react-i18next";

const ProgramCategory = ({
  category,
  showMostPopular,
  selectedCategoryIndex,
  selectCategory,
  idx,
  t,
}) => (
  <button
    type="button"
    data-button-type={
      selectedCategoryIndex === idx && !showMostPopular
        ? "outline"
        : "secondary"
    }
    className="cat-tag"
    key={idx}
    onClick={() => selectCategory(idx, category)}
  >
    {category ? (
      <span>
        {category === "Uncategorized"
          ? t("store.uncategorized")
          : category}
      </span>
    ) : (
      <>
        <input
          type="text"
          placeholder={t("store.subHeader.placeholderCategory")}
          className="trik"
        />
        <span
          className="trik"
          style={{
            color: "var(--green)",
            fontSize: 16,
            cursor: "pointer",
          }}
        >
          +
        </span>
      </>
    )}
  </button>
);

const SubHeader = ({
  programCategories = [],
  toggleMostPopular,
  addCategory,
  showMostPopular,
  selectedCategoryIndex,
  selectCategory,
}) => {
  const { t } = useTranslation("coaching-portal");
  const goToAllPrograms = () => {
    if (showMostPopular) {
      toggleMostPopular();
    }

    submit("/actions/refresh?", {
      method: "GET",
      body: {
        selectedCategoryIndex: "all",
      },
    });
  };

  const programCategoriesModified = [...programCategories, "Uncategorized"];

  return (
    <hgroup className="header-categories">
      <button
        type="button"
        onClick={() => {
          goToAllPrograms();
        }}
        data-button-type={
          !showMostPopular &&
          (selectedCategoryIndex === "all" ||
            (!selectedCategoryIndex &&
              typeof selectedCategoryIndex !== "number"))
            ? "outline"
            : "secondary"
        }
      >
        <span>{t("store.subHeader.all")}</span>
      </button>
      {programCategoriesModified?.map((category, idx) => (
        <ProgramCategory
          key={`${category}`}
          idx={idx}
          category={category}
          showMostPopular={showMostPopular}
          selectedCategoryIndex={selectedCategoryIndex}
          selectCategory={selectCategory}
          t={t}
        />
      ))}

      <button
        type="button"
        data-button-type={showMostPopular ? "outline" : "secondary"}
        onClick={() => toggleMostPopular()}
        className="gap-2"
      >
        <img alt={t("store.subHeader.starAlt")} src="/img/new-icons/golden-star.svg" />
        <span>{t("store.subHeader.mostPopular")}</span>
      </button>
      <button
        type="button"
        data-button-type="secondary"
        data-icon
        onClick={() => addCategory()}
      >
        <SvgIcon alt={t("store.subHeader.addAlt")} src="/img/new-icons/add.svg" />{" "}
        {t("store.subHeader.addCategory")}
      </button>
    </hgroup>
  );
};

export default SubHeader;
